const LegalH2: React.FC<{
  children: string;
}> = ({ children }) => <h2 className="font-20 font-medium">{children}</h2>;

export default LegalH2;
